// Abu Dhabi - prenatal and postnatal personal trainer.
const content = {
    slug: 'prenatal-postnatal-personal-trainer',
    title: 'Prenatal & Postnatal Personal Trainer in Abu Dhabi',
    description: (c) =>
        `Pregnancy and postnatal personal training in Abu Dhabi at home, with female trainers on request. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Abu Dhabi · Pre & postnatal',
    h1: 'Prenatal and Postnatal Personal Trainer in Abu Dhabi',
    lead: 'From the second trimester to getting your strength back after the baby arrives - home sessions with a trainer who knows what is safe at each stage.',
    image: 'personal-trainer/mother-with-her-baby-daughter-practice-yoga-home.jpg',
    imageAlt: 'Mother exercising at home with her baby',
    facts: ['Stage-by-stage plans', 'Female trainers', 'Baby-friendly sessions'],
    ctaLabel: 'Request a pre/postnatal trainer',
    matchSummary: 'a prenatal or postnatal personal trainer in Abu Dhabi',
    packagesTitle: 'Packages',
    packagesIntro: 'Shorter packages suit pregnancy; many mothers continue on a longer package after their postnatal check.',
    sections: [
        {
            title: 'Stage by stage',
            cards: [
                { title: 'First trimester', body: 'Keep doing what you did before, a bit lighter. Rest when tired.' },
                { title: 'Second trimester', body: 'Strength for posture and back comfort; avoid lying flat for long.' },
                { title: 'Third trimester', body: 'Mobility, breathing and pelvic floor; preparation for birth.' },
                { title: 'First 6 weeks after birth', body: 'Walking and breathing only, plus gentle pelvic floor work.' },
                { title: 'After your postnatal check', body: 'Core rebuilding, then strength, then intensity - at your pace.' },
                { title: 'Back to full training', body: 'Usually three to six months after birth, depending on delivery and recovery.' },
            ],
        },
        {
            title: 'Safety first',
            tone: 'muted',
            paragraphs: [
                'Every plan follows your doctor\'s advice. Stop and call your doctor if you feel dizzy, short of breath, have pain or bleeding. In summer, all sessions stay indoors - overheating is a risk in pregnancy, and Abu Dhabi afternoons are no place to exercise outside.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Can I start personal training while pregnant?',
            answer: 'Yes, with your doctor\'s OK. If you were not exercising before, sessions start gently and build slowly.',
        },
        {
            question: 'Can the baby be in the room during postnatal sessions?',
            answer: 'Yes - many sessions happen around feeds and naps. Your trainer plans for interruptions.',
        },
    ],
    schema: { name: 'Prenatal and Postnatal Personal Training in Abu Dhabi' },
}

export default content
